/**
 * Fórmula canônica do módulo Equipe — sem dependência de banco.
 * Testável diretamente sem mocks. Em `shared/` (não `server/lib/`) porque o
 * client também precisa dela: o rodapé "Sai em" de financeiro.tsx usa esta
 * MESMA função para o total da folha de diaristas, em vez de somar `valor`
 * bruto de todos os tipos de diária (o que somaria DESCONTO/ADIANTAMENTO como
 * se fossem a favor, em vez de subtraí-los).
 */

/**
 * ALLOWLIST de folha. MENSALISTA (diária de registro do mensalista, sempre valor 0)
 * está DELIBERADAMENTE fora: o registro rastreia ciclo/presença e nunca é pago.
 * A exclusão é POR TIPO, não por valor — uma linha MENSALISTA com valor plantado no
 * banco continua fora do bruto e fora da contagem de dias.
 */
export const TIPOS_TRABALHO = ["NORMAL", "MEIA_DIARIA", "HORA_EXTRA", "EMPREITA"] as const;

export const PESO_DIA: Record<string, number> = {
  NORMAL: 1,
  MEIA_DIARIA: 0.5,
  HORA_EXTRA: 0,
  EMPREITA: 0,
};

export interface ResumoFormula {
  bruto: number;
  descontos: number;
  adiantamentos: number;
  liquido: number;
  dias: number;
}

/**
 * Recebe um array de linhas {tipo, valor} e retorna o resumo financeiro canônico.
 *
 * bruto     = Σ valor dos tipos de trabalho (NORMAL, MEIA_DIARIA, HORA_EXTRA, EMPREITA)
 * descontos = Σ valor das diárias DESCONTO
 * adiant.   = Σ valor das diárias ADIANTAMENTO
 * liquido   = bruto − descontos − adiantamentos
 * dias      = Σ peso(tipo): NORMAL=1, MEIA_DIARIA=0.5, HORA_EXTRA=0, EMPREITA=0
 */
export function calcFormula(rows: Array<{ tipo: string; valor: string | number }>): ResumoFormula {
  let bruto = 0, descontos = 0, adiantamentos = 0, dias = 0;
  for (const r of rows) {
    const v = typeof r.valor === "number" ? r.valor : parseFloat(r.valor) || 0;
    if ((TIPOS_TRABALHO as readonly string[]).includes(r.tipo)) {
      bruto += v;
      // Não conta dias quando valor=0 (FALTOU zera o valor da tarefa)
      if (v > 0) dias += PESO_DIA[r.tipo] ?? 0;
    } else if (r.tipo === "DESCONTO") {
      descontos += v;
    } else if (r.tipo === "ADIANTAMENTO") {
      adiantamentos += v;
    }
  }
  return { bruto, descontos, adiantamentos, liquido: bruto - descontos - adiantamentos, dias };
}
